module.exports = __webpack_public_path__ + "static/copper-fe4fd0a5739cb80dfd48f0e1ae908f44.png";